<mat-sidenav-container class="h-full">
  <mat-sidenav
    #drawer
    class="!w-[75%] bg-white !rounded-none !fixed"
    mode="over"
    (keydown.escape)="drawer.close()">
    <mat-toolbar
      class="flex !bg-white pointer !p-0"
      [style.background-color]="'var(--color-scania-blue)'"
      (click)="drawer.close()">
      <button class="w-full h-full flex items-center cursor-pointer">
        <mat-icon class="!text-grey-700 px-[24px] !size-[28px] !text-[28px]">close</mat-icon>
      </button>
    </mat-toolbar>

    <mat-nav-list class="!p-0">
      @for (navItem of navItems; track navItem) {
        <a mat-list-item [routerLink]="[navItem.path]" routerLinkActive="!bg-blue-50 border-l-4 border-l-blue-400"
           class="border-radius-0 p-0 !h-[68px] !rounded-none !flex border-b-1 border-b-grey-400 hover:!bg-blue-50">
          <span class="px-[24px] !h-full !w-full !font-header-bold">
            {{ navItem.label }}
          </span>
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar
      class="!px-0 h-14 flex items-center"
      [style.background-color]="'var(--color-scania-blue)'">

      <!-- Hamburger on mobile -->
      <button
        class="!text-grey-400 md:!hidden flex items-center p-8 !border-r border-r-blue-700 cursor-pointer h-[64px]"
        (click)="toggleMenu()">
        <mat-icon>menu</mat-icon>
      </button>

      <span class="text-white flex items-center !font-headline text-base p-8 !border-l border-l-blue-700 h-[64px]">
        {{ appName }}
      </span>

      <nav class="md:flex md:flex-1 hidden">
        @for (navItem of navItems; track navItem) {
          <button>
            <a [routerLink]="[navItem.path]" routerLinkActive="bg-blue-700 border-b border-b-4 border-b-blue-400"
               class="text-white !font-header-bold text-[14px] px-[24px]  h-full flex justify-center items-center hover:bg-blue-700 border-l border-l-blue-700">{{ navItem.label }}</a>
          </button>
        }

        <span class="flex-1"></span>

        <button mat-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
                class="!h-[64px] !w-[64px] flex justify-center items-center !border-l border-blue-700">
          @if (profileImage()){
            <img class="h-9 rounded-full" [src]="profileImage()" alt="scania-logo"/>
          }
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>info</mat-icon>
            <span>{{buildTimestamp}}</span>
          </button>
          <button mat-menu-item class="!border-b !border-grey-300">
            <span class="font-bold">{{ displayName() }}</span>
          </button>
          <button mat-menu-item class="!border-b !border-grey-300" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
        <span class="h-[64px] w-[64px] flex justify-center items-center border-l border-blue-700">
          <img class="h-9 " [src]="logoPath" alt="scania-logo"/>
        </span>
      </nav>
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container>
